"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABANDONED_CART = exports.PROVIDERS = exports.PAGES_INTEREST = exports.PAGE_VIEW = exports.CONTENT_INTEREST = exports.ENGAGEMENT_LEVEL = exports.TEALIUM = exports.KEYWORD = exports.PURCHASE_FREQUENCY = exports.LAST_PURCHASE = exports.DATALAYER = exports.SELECTOR = exports.ACTION_TRACKING = exports.CUSTOM_VARIABLE = exports.CODE = exports.URL_PARAMETER = exports.ECOMMERCE_VARIABLE = exports.DAYS_SINCE_FIRST_SESSION = exports.DAYS_SINCE_LAST_SESSION = exports.WEATHER = exports.SESSION_NUMBER = exports.ADBLOCK = exports.SAME_DAY_VISIT = exports.NUMBER_PAGES_VIEWED = exports.SOURCE = exports.CAMPAIGN_EXPOSITION = exports.JS_VARIABLE = exports.SCREEN_SIZE = exports.PREVIOUS_PAGE = exports.SOURCE_TYPE = exports.RETURNING_VISITOR = exports.BROWSER = exports.LANDING_PAGE = exports.BROWSER_LANGUAGE = exports.COOKIE = exports.GEOLOCALISATION = exports.IP = exports.DEVICE = exports.SIRDATA_DMP = exports.MEDIARITHMICS_DMP = exports.LIVERAMP_DMP = exports.ADOBE_DMP = exports.TEMELIO_DMP = exports.WEBORAMA_DMP = exports.KRUX_DMP = exports.ADVALO_DMP = exports.YSANCE_DMP = exports.BLUEKAI_DMP = exports.TAGCOMMANDER_DMP = exports.EULERIAN_DMP = void 0;
exports.NPS = exports.CSAT = void 0;
/**
 * These are ids of all possible targeting criterias.
 *
 */
exports.EULERIAN_DMP = 1;
exports.TAGCOMMANDER_DMP = 2;
exports.BLUEKAI_DMP = 4;
exports.YSANCE_DMP = 5;
exports.ADVALO_DMP = 6;
exports.KRUX_DMP = 7;
exports.WEBORAMA_DMP = 8;
exports.TEMELIO_DMP = 9;
exports.ADOBE_DMP = 10;
exports.LIVERAMP_DMP = 11;
exports.MEDIARITHMICS_DMP = 12;
exports.SIRDATA_DMP = 16;
exports.DEVICE = 17;
exports.IP = 18;
exports.GEOLOCALISATION = 19;
exports.COOKIE = 20;
exports.BROWSER_LANGUAGE = 21;
exports.LANDING_PAGE = 22;
exports.BROWSER = 23;
exports.RETURNING_VISITOR = 24;
exports.SOURCE_TYPE = 25;
exports.PREVIOUS_PAGE = 26;
exports.SCREEN_SIZE = 27;
exports.JS_VARIABLE = 28;
exports.CAMPAIGN_EXPOSITION = 29;
exports.SOURCE = 30;
exports.NUMBER_PAGES_VIEWED = 31;
exports.SAME_DAY_VISIT = 32;
exports.ADBLOCK = 33;
exports.SESSION_NUMBER = 34;
exports.WEATHER = 35;
exports.DAYS_SINCE_LAST_SESSION = 36;
exports.DAYS_SINCE_FIRST_SESSION = 37;
exports.ECOMMERCE_VARIABLE = 38;
exports.URL_PARAMETER = 39;
exports.CODE = 40;
exports.CUSTOM_VARIABLE = 41;
exports.ACTION_TRACKING = 42;
exports.SELECTOR = 43;
exports.DATALAYER = 44;
exports.LAST_PURCHASE = 45;
exports.PURCHASE_FREQUENCY = 46;
exports.KEYWORD = 47;
exports.TEALIUM = 48;
exports.ENGAGEMENT_LEVEL = 49;
exports.CONTENT_INTEREST = 50;
exports.PAGE_VIEW = 51;
exports.PAGES_INTEREST = 52;
exports.PROVIDERS = 53;
exports.ABANDONED_CART = 54;
exports.CSAT = 55;
exports.NPS = 56;
//# sourceMappingURL=targetingTypes.js.map